<app-tab-navigation-header [title]="title" [detail]="companyName">
	<div
		class="company-entity-placeholder"
		[appBreadcrumbLabel]="breadcrumbLabel"
		[attr.data-automation-id]="automationId"
	>
		<p>{{ message }}</p>
	</div>
</app-tab-navigation-header>
